// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IApplyUnmatchedInvoicesRequestDto
 */
export interface IApplyUnmatchedInvoicesRequestDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof IApplyUnmatchedInvoicesRequestDto
     */
    invoices_ids: Array<number>;
}

/**
 * Check if a given object implements the IApplyUnmatchedInvoicesRequestDto interface.
 */
export function instanceOfIApplyUnmatchedInvoicesRequestDto(value: object): value is IApplyUnmatchedInvoicesRequestDto {
    if (!('invoices_ids' in value) || value['invoices_ids'] === undefined) return false;
    return true;
}

export function IApplyUnmatchedInvoicesRequestDtoFromJSON(json: any): IApplyUnmatchedInvoicesRequestDto {
    return IApplyUnmatchedInvoicesRequestDtoFromJSONTyped(json, false);
}

export function IApplyUnmatchedInvoicesRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IApplyUnmatchedInvoicesRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'invoices_ids': json['invoicesIds'],
    };
}

export function IApplyUnmatchedInvoicesRequestDtoToJSON(json: any): IApplyUnmatchedInvoicesRequestDto {
    return IApplyUnmatchedInvoicesRequestDtoToJSONTyped(json, false);
}

export function IApplyUnmatchedInvoicesRequestDtoToJSONTyped(value?: IApplyUnmatchedInvoicesRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoicesIds': value['invoices_ids'],
    };
}

